import { useEffect, useState } from 'react';

export type ThemeMode = 'light' | 'dark';

const THEME_STORAGE_KEY = 'cyclone-theme';

/**
 * 테마 설정을 관리하는 훅
 * - localStorage에 테마 설정 저장
 * - HTML root에 data-opds-theme attribute 적용
 * - 시스템 테마 기본값 사용 (prefers-color-scheme)
 */
export const useTheme = () => {
  const [theme, setThemeState] = useState<ThemeMode>(() => {
    // 1. localStorage 확인
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') {
      return stored;
    }

    // 2. 기본값: 라이트 테마
    return 'light';
  });

  useEffect(() => {
    // HTML root에 data-opds-theme attribute 설정
    document.documentElement.setAttribute('data-opds-theme', theme);

    // localStorage에 저장
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = () => {
    setThemeState((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  const setTheme = (newTheme: ThemeMode) => {
    setThemeState(newTheme);
  };

  return {
    theme,
    setTheme,
    toggleTheme,
    isDark: theme === 'dark',
    isLight: theme === 'light',
  };
};
